import ConfigPossibleValue from '../model/config.possible.value';
import ConfigProperty from '../model/config.property';
import Module from '../core/module';

import { ask, } from '../utils/popups';
import { get } from '../http/api';
import { requestify } from '../utils/promisify';
import { error } from '../ui/messages'
import { handle } from '../service/messages';  

export default Module.extend( {

    initialize(options = {}) {
        Module.prototype.initialize.call( this, options );

        this.state_ = {
            breadcrumbs: [],
            terminalPropertyName: undefined,
            // todo: don't allow just close edit form
            editingPossibleValue: undefined,
            creatingPossibleValue: undefined,
            createIntermediatePropertyAttrs: undefined,
            createTerminalPropertyAttrs: undefined,
            editIntermediatePropertyAttrs: undefined,
            editTerminalPropertyAttrs: undefined,
            createSectionAttrs: undefined,
            editSectionAttrs: undefined,
        };
    },
    
    template: 'jst/module.configuration',

    open() {
        return get( '/configuration/root?apiVersion=1.4' ).cerebellum().blocking()
            .map( response => response.root_property )
            .execute()
            .then( configRoot => this.configRoot_ = configRoot )
            .then( () => console.log( 'before render', this.configRoot_ ) )
            .then( () => this.render() );
    },

    serialize() {
        const {
            breadcrumbs, 
            terminalPropertyName,
            editingPossibleValue,
            creatingPossibleValue,
            createIntermediatePropertyAttrs,
            createTerminalPropertyAttrs,
            editIntermediatePropertyAttrs,
            editTerminalPropertyAttrs,
            createSectionAttrs,
            editSectionAttrs,
        } = this.state_;

        const { roles, } = this.options;

        const currentProperty = this.getCurrentIntermediateProperty();
        const poppedBreadcrumbs = [...(breadcrumbs || [])];
        poppedBreadcrumbs.pop();
        const parentProperty = this.getCurrentIntermediateProperty( poppedBreadcrumbs ) || this.configRoot_;
        const terminalProperty = this.getCurrentTerminalProperty();
        const [activeSection] = breadcrumbs;

        const possibleValueModel = editingPossibleValue
                ? new ConfigPossibleValue( editingPossibleValue )
                : undefined;

        const createPossibleValueModel = creatingPossibleValue
                ? new ConfigPossibleValue( creatingPossibleValue )
                : undefined;

        const createIntermediatePropertyModel = createIntermediatePropertyAttrs
                ? new ConfigProperty( createIntermediatePropertyAttrs )
                : undefined;

        const editIntermediatePropertyModel = editIntermediatePropertyAttrs
                ? new ConfigProperty( editIntermediatePropertyAttrs )
                : undefined;

        const editTerminalPropertyModel = editTerminalPropertyAttrs
                ? new ConfigProperty( editTerminalPropertyAttrs )
                : undefined;

        const createTerminalPropertyModel = createTerminalPropertyAttrs
                ? new ConfigProperty( createTerminalPropertyAttrs )
                : undefined;

        const createSectionModel = createSectionAttrs 
                ? new ConfigProperty( createSectionAttrs )
                : undefined;

        const editSectionModel = editSectionAttrs 
                ? new ConfigProperty( editSectionAttrs )
                : undefined;

        console.log( 'before sections = [...]' );

        const sections = [...this.configRoot_.children];

        console.log( 'serialize done' );

        return {
            breadcrumbs,
            currentProperty,
            parentProperty,
            terminalProperty,
            possibleValueModel,
            createPossibleValueModel,
            createIntermediatePropertyModel,
            createTerminalPropertyModel,
            editIntermediatePropertyModel,
            editTerminalPropertyModel,
            createSectionModel,
            editSectionModel,
            activeSection,
            sections,
            roles,
            isTopProperty: this.configRoot_.children.includes( currentProperty ),
        };
    },

    url() {
        return 'configuration';
    },

    getCurrentIntermediateProperty(breadcrumbs) {
        if (!breadcrumbs)
            breadcrumbs = this.state_.breadcrumbs;
        if (!breadcrumbs || !breadcrumbs.length)
            return null;

        return breadcrumbs.reduce( (currentProperty, crumbItem) => {
            const {children} = currentProperty;
            const nextProperties = children.filter( property => property.name === crumbItem.name );
            const [nextProperty] = nextProperties.filter( property => property.array_index == crumbItem.array_index );

            return nextProperty;
        }, this.configRoot_ );
    },

    getCurrentTerminalProperty() {
        const {terminalPropertyName} = this.state_;
        if (!terminalPropertyName)
            return undefined;

        const [terminalProperty] = this.getCurrentIntermediateProperty()
            .children
            .filter( childProperty => childProperty.name === terminalPropertyName );

        return terminalProperty;
    },

    [Module.event( 'Sections:section:choose' )]({id, name, label, array_index}) {
        const {breadcrumbs} = this.state_;

        this.setState( {
            breadcrumbs: [{ id, name, label, array_index }],
            terminalPropertyName: undefined,
            editingPossibleValue: undefined,
            createIntermediatePropertyAttrs: undefined,
            createTerminalPropertyAttrs: undefined,
            createSectionAttrs: undefined,
            editSectionAttrs: undefined,
        } );
        this.navigated();

        this.render();
    },

    [Module.event( 'Sections:section:add-start' )]() {
        this.setState( {
            createSectionAttrs: {
                is_terminal: false,
            },
            editSectionAttrs: undefined,
        } );
        this.navigated();

        this.render()
            .then( () => this.SectionForm.focus() );
    },

    [Module.event( 'Sections:section:edit-start' )](sectionAttrs) {
        this.setState( {
            createSectionAttrs: undefined,
            editSectionAttrs: { ...sectionAttrs },
        } );
        this.navigated();

        this.render()
            .then( () => this.SectionForm.focus() );
    },

    [Module.event( 'SectionForm:intermediate-property:add-edit-cancel' )]() {
        this.setState( {
            createSectionAttrs: undefined,
            editSectionAttrs: undefined,
        } );
        this.navigated();

        this.render();
    },

    [Module.event( 'SectionForm:intermediate-property:add-edit-save' )](sectionAttrs) {
        let propertyAttrsToSave;
        if (sectionAttrs.id) {
            // edit mode
            propertyAttrsToSave = { ...sectionAttrs };
        } else {
            // add mode
            propertyAttrsToSave = { ...this.configRoot_ };
            propertyAttrsToSave.children = [...propertyAttrsToSave.children, sectionAttrs];
        }

        saveTerminalProperty.call( this, propertyAttrsToSave )
            .then( () => {
                this.setState( {
                    createSectionAttrs: undefined,
                    editSectionAttrs: undefined,
                } );
                this.navigated();
        
                this.render();
            } )
            .catch( message => handle( this.SectionForm, error( message ) ) );
    },

    [Module.event( 'Sections:section:remove' )](sectionId) {
        ask( 'configuration::section - modal delete - confirmation text',
            'configuration::section - modal delete - title', 
            'actions::yes', 
            'actions::no',
            () => {
                const currentProperty = { ...this.configRoot_ };
                currentProperty.children = currentProperty.children 
                    .filter( childProperty => childProperty.id != sectionId );
        
                saveTerminalProperty.call( this, currentProperty )
                    .then( () => {
                        this.setState( {
                            // no edit after delete cause maybe editing item
                            // has been deleted
                            editSectionAttrs: undefined,
                        } );
                        this.navigated();
                
                        this.render();
                    } )
                    .catch( message => handle( this, error( message ) ) );
            } );
    },

    [Module.event( 'Properties:property:level-up' )]() {
        const {breadcrumbs} = this.state_;
        const newBreadCrumbs = [...breadcrumbs];
        newBreadCrumbs.pop();

        this.setState( {
            breadcrumbs: newBreadCrumbs,
            terminalPropertyName: undefined,
            editingPossibleValue: undefined,
            createIntermediatePropertyAttrs: undefined,
            createTerminalPropertyAttrs: undefined,
        } );
        this.navigated();
        
        this.render();
    },

    [Module.event( 'Properties:property:enter-item' )]({id, name, label, array_index}) {
        const {breadcrumbs} = this.state_;

        this.setState( {
            breadcrumbs: [...breadcrumbs, { id, name, label, array_index }],
            terminalPropertyName: undefined,
            editingPossibleValue: undefined,
            createIntermediatePropertyAttrs: undefined,
            createTerminalPropertyAttrs: undefined,
        } );
        this.navigated();
        
        this.render();
    },

    [Module.event( 'Breadcrumb:set-page' )]({id, name, label, array_index}) {
        const {breadcrumbs} = this.state_;
        const newBreadCrumbs = [...breadcrumbs];
        newBreadCrumbs.pop();

        this.setState( {
            breadcrumbs: [...newBreadCrumbs, { id, name, label, array_index }],
            terminalPropertyName: undefined,
            editingPossibleValue: undefined,
            createIntermediatePropertyAttrs: undefined,
            createTerminalPropertyAttrs: undefined,
        } );
        this.navigated();
        
        this.render();
    },

    [Module.event( 'Properties:property:show-possible-values' )](name) {
        this.setState( {
            terminalPropertyName: name,
            editingPossibleValue: undefined,
        } );
        this.navigated();

        this.render();
    },

    [Module.event( 'Values:possible-value:add-start' )]() {
        const terminalProperty = this.getCurrentTerminalProperty();
        const {type} = terminalProperty;

        this.setState( {
            creatingPossibleValue: { 
                type,
                order_index: terminalProperty.possible_values
                    .map( possibleValue => possibleValue.order_index )
                    .reduce( (a, b) => Math.max( a, b ), 0 ) + 1
            },
        } );
        this.navigated();

        this.render()
            .then( () => this.CreatePossibleValue.focus() );
    },

    [Module.event( ':possible-value:edit-start' )](possibleValue) {
        const terminalProperty = this.getCurrentTerminalProperty();
        const {type} = terminalProperty;

        possibleValue = { ...possibleValue, type };
        this.setState( {
            editingPossibleValue: possibleValue,
        } );
        this.navigated();

        this.render()
            .then( () => {
                const {possible_values: possibleValues} = terminalProperty,
                    sorted = [...possibleValues].sort( (a, b) => a.order_index - b.order_index ),
                    viewIndex = sorted.findIndex( item => item.id === possibleValue.id );
                if (this.Values[viewIndex] && this.Values[viewIndex].focus)
                    this.Values[viewIndex].focus();
            } );
    },

    // used for both add and edit mode
    [Module.event( ':possible-value:add-edit-cancel' )]() {
        this.setState( {
            editingPossibleValue: undefined,
            creatingPossibleValue: undefined,
        } );
        this.navigated();

        this.render();
    },

    [Module.event( ':possible-value:edit-save' )](possibleValueAttrs) {
        const terminalPropertyAttrs = { ...this.getCurrentTerminalProperty() };
        terminalPropertyAttrs.possible_values = terminalPropertyAttrs.possible_values
            .map( possibleValue => { 
                if (possibleValue.id === possibleValueAttrs.id)
                    return possibleValueAttrs;
                // don't make { ...possibleValue } here,
                // { ...currentTerminalProperty } is enough.
                return possibleValue;
            } );
        
        saveTerminalProperty.call( this, terminalPropertyAttrs )
            .catch( message => {
                const {possible_values: possibleValues} = terminalPropertyAttrs,
                    sorted = [...possibleValues].sort( (a, b) => a.order_index - b.order_index ),
                    viewIndex = sorted.findIndex( item => item.id === possibleValueAttrs.id );
        
                handle( this.Values[viewIndex], error( message ) );
            } );
    },

    [Module.event( ':possible-value:add-save' )](possibleValueAttrs) {
        const {type} = possibleValueAttrs;
        if (type === 'BOOLEAN')
            if (possibleValueAttrs.value === undefined)
                possibleValueAttrs.value = false;

        const terminalPropertyAttrs = { ...this.getCurrentTerminalProperty() };
        // don't make { ...possibleValue } here,
        // { ...currentTerminalProperty } is enough.
        terminalPropertyAttrs.possible_values = [...terminalPropertyAttrs.possible_values, possibleValueAttrs];
        
        saveTerminalProperty.call( this, terminalPropertyAttrs )
            .catch( message => handle( this.CreatePossibleValue, error( message ) ) );
    },

    [Module.event( ':possible-value:remove' )](possibleValueAttrs) {
        ask( 'configuration::possible value - modal delete - confirmation text', 
            'configuration::possible value - modal delete - confirmation title',
            'actions::yes', 
            'actions::no',
            () => {
                const currentProperty = { ...this.getCurrentTerminalProperty() };
                currentProperty.possible_values = currentProperty.possible_values
                    .filter( childProperty => childProperty.id != possibleValueAttrs.id );
        
                saveTerminalProperty.call( this, currentProperty )
                    .then( () => {
                        this.setState( {
                            editingPossibleValue: undefined,
                        } );
                        this.navigated();
                
                        this.render();
                    } )
                    .catch( message => handle( this, error( message ) ) );
            } );

    },

    [Module.event( ':possible-value:order-up' )](possibleValueAttrs) {
        changePossibleValueOrder.call( this, possibleValueAttrs, -1 );
    },

    [Module.event( ':possible-value:order-down' )](possibleValueAttrs) {
        changePossibleValueOrder.call( this, possibleValueAttrs, 1 );
    },

    [Module.event( 'PropertyActions:intermediate-property:add-start' )]() {
        this.setState( {
            createIntermediatePropertyAttrs: {
                is_terminal: false,
            },
        } );
        this.navigated();

        this.render()
            .then( () => this.IntermediatePropertyForm.focus() );
    },

    [Module.event( 'PropertyActions:terminal-property:add-start' )]() {
        this.setState( {
            createTerminalPropertyAttrs: {
                is_terminal: true,
            },
        } );
        this.navigated();

        this.render()
            .then( () => this.TerminalPropertyForm.focus() );
    },

    [Module.event( 'Properties:intermediate-property:edit-start' )](intermediatePropertyAttrs) {
        this.setState( {
            createIntermediatePropertyAttrs: undefined,
            editIntermediatePropertyAttrs: { ...intermediatePropertyAttrs },
            editTerminalPropertyAttrs: undefined,
        } );
        this.navigated();

        this.render()
            .then( () => this.IntermediatePropertyForm.focus() );
    },

    [Module.event( 'Properties:terminal-property:edit-start' )](terminalPropertyAttrs) {
        this.setState( {
            createIntermediatePropertyAttrs: undefined,
            editIntermediatePropertyAttrs: undefined,
            editTerminalPropertyAttrs: { ...terminalPropertyAttrs },
        } );
        this.navigated();

        this.render()
            .then( () => this.TerminalPropertyForm.focus() );
    },

    // used for both add and edit mode
    [Module.event( 'IntermediatePropertyForm:intermediate-property:add-edit-cancel' )]() {
        this.setState( {
            createIntermediatePropertyAttrs: undefined,
            editIntermediatePropertyAttrs: undefined,
        } );
        this.navigated();

        this.render();
    },

    // used for both add and edit mode
    [Module.event( 'TerminalPropertyForm:terminal-property:add-edit-cancel' )]() {
        this.setState( {
            createTerminalPropertyAttrs: undefined,
            editTerminalPropertyAttrs: undefined,
        } );
        this.navigated();

        this.render();
    },

    // used for both add and edit mode
    // todo: validation for duplicated name/label
    [Module.event( 'IntermediatePropertyForm:intermediate-property:add-edit-save' )](intermediatePropertyAttrs) {
        const currentProperty = { ...this.getCurrentIntermediateProperty() };

        if (intermediatePropertyAttrs.id) {
            // edit mode
            const [nameToMatch] = currentProperty.children
                .filter( childProperty => childProperty.id == intermediatePropertyAttrs.id)
                .map( childProperty => childProperty.name );

            currentProperty.children = currentProperty.children
                .map( childProperty => {
                    // no match - no changes
                    if (childProperty.name !== nameToMatch)
                        return childProperty;

                    // same id => full change
                    if (childProperty.id == intermediatePropertyAttrs.id)
                        return intermediatePropertyAttrs;

                        // same name => change name/label only
                    const {name, label, ...otherChildPropertyFields} = childProperty;
                    return {
                        name: intermediatePropertyAttrs.name,
                        label: intermediatePropertyAttrs.label,
                        ...otherChildPropertyFields,
                    };
                } );

            saveIntermediateProperty.call( this, currentProperty )
                .catch( message => handle( this.IntermediatePropertyForm, error( message ) ) );
        } else {
            // add mode
            currentProperty.children = [...currentProperty.children, intermediatePropertyAttrs];

            saveIntermediateProperty.call( this, currentProperty )
                .catch( message => handle( this.IntermediatePropertyForm, error( message ) ) );
        }
    },

    [Module.event( 'Properties:property:append-child-to' )]({name, label}) {
        const currentProperty = { ...this.getCurrentIntermediateProperty() };
        const {children} = currentProperty;

        const array_index = 1 + children.filter( childProperty => childProperty.name == name )
            .map( childProperty => childProperty.array_index )
            .reduce( (a, b) => Math.max( a, b ), 0 );

        currentProperty.children = [...children, {
            name, label,
            is_terminal: false,
            children: [],
            array_index,
        }];

        saveIntermediateProperty.call( this, currentProperty )
            .catch( message => handle( this, error( message ) ) );
    },

    // used for both add and edit mode
    // todo: validation for duplicated name/label
    [Module.event( 'TerminalPropertyForm:terminal-property:add-edit-save' )](terminalPropertyAttrs) {
        if (terminalPropertyAttrs.id) {
            // edit mode
            saveTerminalProperty.call( this, { ...terminalPropertyAttrs } )
                .catch( message => handle( this.TerminalPropertyForm, error( message ) ) );
        } else {
            // add mode
            const currentProperty = { ...this.getCurrentIntermediateProperty() };
            // don't make { ...child } here,
            // { ...currentIntermediateProperty } above is enough.
            currentProperty.children = [...currentProperty.children, terminalPropertyAttrs];

            saveIntermediateProperty.call( this, currentProperty )
                .catch( message => handle( this.TerminalPropertyForm, error( message ) ) );
        }
    },

    [Module.event( 'Properties:property:remove' )](propertyAttrs) {
        const confText = propertyAttrs.is_terminal
                ? 'configuration::terminal property - modal delete - confirmation text'
                : 'configuration::intermediate property - modal delete - confirmation text';

        const confTitle = propertyAttrs.is_terminal
                ? 'configuration::terminal property - modal delete - title'
                : 'configuration::intermediate property - modal delete - title';

        ask( confText, confTitle,
            'actions::yes', 
            'actions::no',
            () => {
                const currentProperty = { ...this.getCurrentIntermediateProperty() };
                currentProperty.children = currentProperty.children
                    .filter( childProperty => childProperty.name != propertyAttrs.name );
        
                saveTerminalProperty.call( this, currentProperty )
                    .then( () => {
                        this.setState( {
                            editTerminalPropertyAttrs: undefined,
                        } );
                        this.navigated();
                
                        this.render();
                    } )
                    .catch( message => handle( this, error( message ) ) );
            } );

    },

    [Module.event( 'Properties:property:remove-sibling' )]({ id, name, array_index}) {
        ask( 'configuration::intermediate property - modal delete - confirmation text', 
            'configuration::intermediate property - modal delete - title',
            'actions::yes', 
            'actions::no',
            () => {
                const currentProperty = { ...this.getCurrentIntermediateProperty() };
                currentProperty.children = currentProperty.children
                    .filter( childProperty => childProperty.id != id )
                    .map( childProperty => {
                        if (childProperty.name === name)
                            if (childProperty.array_index > array_index)
                                childProperty.array_index--;

                        return childProperty;
                    } );

                saveTerminalProperty.call( this, currentProperty )
                    .then( () => {
                        this.setState( {
                            editTerminalPropertyAttrs: undefined,
                            editIntermediatePropertyAttrs: undefined,
                        } );
                        this.navigated();
                
                        this.render();
                    } )
                    .catch( message => handle( this, error( message ) ) );
            } );

    },

} );

// todo unify saveTerminalProperty/saveIntermediateProperty

function saveTerminalProperty(propertyAttrs) {
    const propertyToSave = new ConfigProperty( propertyAttrs );
    return requestify( propertyToSave.save() ).then( ({property: serverBackedProperty}) => {
        const {parent} = propertyById.call( this, serverBackedProperty.id );

        if (!parent)
            this.configRoot_ = serverBackedProperty;
        else
            parent.children = parent.children
                .map( childProperty => {
                    if (childProperty.id === serverBackedProperty.id)
                        return serverBackedProperty;
                    return childProperty;
                } );

        this.setState( {
            creatingPossibleValue: undefined,
            editingPossibleValue: undefined,
            createIntermediatePropertyAttrs: undefined,
            createTerminalPropertyAttrs: undefined,
            editIntermediatePropertyAttrs: undefined,
            editTerminalPropertyAttrs: undefined,
        } );
        this.navigated();

        return this.render();
    } );
}

function saveIntermediateProperty(propertyAttrs) {
    const propertyToSave = new ConfigProperty( propertyAttrs );
    return requestify( propertyToSave.save() ).then( ({property: serverBackedProperty}) => {
        // merge server response into the property tree
        const currentProperty = this.getCurrentIntermediateProperty();
        Object.assign( currentProperty, serverBackedProperty );

        this.setState( {
            creatingPossibleValue: undefined,
            editingPossibleValue: undefined,
            createIntermediatePropertyAttrs: undefined,
            createTerminalPropertyAttrs: undefined,
            editIntermediatePropertyAttrs: undefined,
            editTerminalPropertyAttrs: undefined,
        } );
        this.navigated();

        return this.render();
    } );
}

function propertyById(id) {
    const rec = (child, parent) => {
        if (child.id == id)
            return {
                result: child,
                parent,
            };

        if (child.is_terminal)
            return;

        return child.children.reduce( (found, childProperty) => {
            if (found) return found;
            return rec( childProperty, child );
        }, null );
    };

    return rec( this.configRoot_, null );
}

function changePossibleValueOrder(possibleValueAttrs, nextValueIndexDelta) {
    const currentProperty = { ...this.getCurrentTerminalProperty() };
    const {possible_values} = currentProperty;
    // prepare array of values for further changes
    const values = [...possible_values]
        .sort( (a, b) => a.order_index - b.order_index )
    
    // find possible value to lift up
    const valueIndex = values
        .findIndex( value => value.id == possibleValueAttrs.id );
    // swap-es6-style with upper/lower value 
    [values[valueIndex + nextValueIndexDelta], values[valueIndex]] = 
        [values[valueIndex], values[valueIndex + nextValueIndexDelta]];
    // set new order index
    values.forEach( (value, index) => value.order_index = index );
    // and set values back
    currentProperty.possible_values = values;

    saveTerminalProperty.call( this, currentProperty )
        .then( () => this.render() )
        .catch( message => handle( this, error( message ) ) );
}


// WEBPACK FOOTER //
// ./src/js/module/configuration.js